import { CompanyDataDTO } from "./CompanyDataDTO";
import { ContractDTO } from "./ContractDTO";
import { DataAnalysisSettingsDTO } from "./DataAnalysisSettingsDTO";
import { InitialRegistrationSettingsDTO } from "./InitialRegistrationSettingsDTO";
import { JwtSettingsDTO } from "./JwtSettingsDTO";
import { LoginSettings } from "./LoginSettings";
import { SubscriptionFeaturesDTO } from "./SubscriptionFeaturesDTO";
import { SubscriptionPlan } from "./SubscriptionPlan";
import { SubscriptionSettingsDTO } from "./SubscriptionSettingsDTO";
import { SubscriptionTypeEnumDTO } from "./SubscriptionTypeEnumDTO";
import { ThemeDTO } from "./ThemeDTO";

export class SubscriptionInsertDTO {
    constructor(sub?) {
        sub = sub || {};

        this.active = sub.active || false;
        this.dataReviewRequestedAt = sub.dataReviewRequestedAt || null;
        this.name = sub.name || "";
        this.description = sub.description || "";
        this.type = sub.type || SubscriptionTypeEnumDTO.BusinessUc;
        this.host = sub.host || "";
        this.companyData = new CompanyDataDTO(sub.companyData);
        this.jwtSettings = new JwtSettingsDTO(sub.jwtSettings);
        this.theme = new ThemeDTO(sub.theme);
        this.features = new SubscriptionFeaturesDTO(sub.features);
        this.settings = new SubscriptionSettingsDTO(sub.settings);
        this.contract = new ContractDTO(sub.contract);
        this.dataAnalysisSettings = sub.dataAnalysisSettings || null;
        this.loginSettings = new LoginSettings(sub.loginSettings);
        this.plan = sub.plan || SubscriptionPlan.Free;
        this.initialRegistrationSettings =
            sub.initialRegistrationSettings || new InitialRegistrationSettingsDTO(sub.initialRegistrationSettings);
    }

    active: boolean;
    dataReviewRequestedAt: string | null;
    name: string;
    description: string;
    type: SubscriptionTypeEnumDTO;
    host: string;
    companyData: CompanyDataDTO;
    jwtSettings: JwtSettingsDTO;
    theme: ThemeDTO;
    features: SubscriptionFeaturesDTO;
    settings: SubscriptionSettingsDTO;
    contract: ContractDTO;
    dataAnalysisSettings: DataAnalysisSettingsDTO;
    loginSettings: LoginSettings;
    plan: SubscriptionPlan;
    initialRegistrationSettings: InitialRegistrationSettingsDTO;
}
